import { OptionTemplate } from "shared/api/middleware-api-client";
import {
  getHandleFamilyPolicy,
  isHandleAllowedForPolicy,
  isUsableHandleOption,
  resolvePreferredHandleForPolicy,
} from "./handlePolicy";

export interface NormalizeInitialHandleResult {
  nextHandle: OptionTemplate | null;
  changed: boolean;
}

/**
 * Guarantees a valid handle when entering via URL for any restricted handle policy.
 */
export const normalizeInitialHandle = (
  doorCode: string | null | undefined,
  layoutCode: string | null | undefined,
  handleCode: string | null | undefined,
  handleOptions: OptionTemplate[],
  anchorBeamGap?: number | null,
): NormalizeInitialHandleResult => {
  const door = (doorCode ?? "").trim();
  const layout = (layoutCode ?? "").trim();
  const handle = (handleCode ?? "").trim();
  const handlePolicy = getHandleFamilyPolicy(door, layout);

  if (handlePolicy === "unrestricted") {
    return { nextHandle: null, changed: false };
  }

  const found = handleOptions.find(
    (o) => o.type === "handle" && o.code === handle,
  );
  if (
    found &&
    isUsableHandleOption(found, layout) &&
    isHandleAllowedForPolicy(
      found.code,
      handlePolicy,
      door,
      anchorBeamGap,
      layout,
    )
  ) {
    return { nextHandle: found, changed: false };
  }

  const fallback = resolvePreferredHandleForPolicy({
    anchorBeamGap,
    doorCode: door,
    layoutCode: layout,
    handleOptions,
  });

  return {
    nextHandle: fallback,
    changed: !!fallback && fallback.code !== handle,
  };
};
